import { render, staticRenderFns } from "./DownloadCard.vue?vue&type=template&id=7a5b0264&scoped=true"
import script from "./DownloadCard.vue?vue&type=script&lang=js"
export * from "./DownloadCard.vue?vue&type=script&lang=js"
import style0 from "./DownloadCard.vue?vue&type=style&index=0&id=7a5b0264&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a5b0264",
  null
  
)

export default component.exports